module.exports = __webpack_public_path__ + "img/default.0e0a4436.png";